import jwtDecode, { JwtPayload } from "jwt-decode";

export const parseJwt = (token: string) => {
  return jwtDecode<JwtPayload>(token);
};

// ripped off from here https://stackoverflow.com/questions/43886878/auth0-and-vue-error-in-render-function-invalidtokenerror-invalid-token-speci
export const parseJwtExtra = (token: string) => {
  var base64Url = token.split(".")[0];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function(c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
};
